import { Event } from "./Event";

export class LoaderEvent extends Event
{
    static readonly COMPLETE = "complete";
    static readonly CHILD_COMPLETE = "childComplete";
    static readonly PROGRESS = "progress";
    static readonly CHILD_PROGRESS = "childProgress";
    static readonly ERROR = "error";
    static readonly CHILD_ERROR = "childError";
    static readonly DECODE_ERROR = "decodeError";

    constructor(type: string, data: any = null)
    {
        super(type, data, false);
    }
}
